'use strict';

// Vendor modules
require('../vendor/frontend/jquery.maskedinput.min.js');
require('../vendor/frontend/analytics.js');
require('../vendor/frontend/analytics_init.js');
require('../vendor/frontend/ios-orientationchange-fix.js');

const IEPlaceholderFix = require('../vendor/frontend/ie-placeholder');

const { I18n } = window;

const I18nRoot = 'js.modules.mobile.';

function renderSendInactive() {
  $('#submitButton').addClass('inactive');
  $('#submitButton').attr('value', 'Sending ...');
}
function renderSendActive() {
  $('#submitButton').removeClass('inactive');
  $('#submitButton').attr(
    'value',
    I18n.translate(`${I18nRoot}mobile_send_btn`)
  );
}

function displayErrors(msg) {
  $('div.error')
    .html(msg)
    .show();
  $('#message_to').addClass('error');
}

function removeErrors() {
  $('div.error')
    .html('')
    .hide();
  $('#message_to').removeClass('error');
}

function maskTextField() {
  $.mask.definitions['~'] = '([0-9] )?';
  $('.phoneMasked').mask(I18n.translate(`${I18nRoot}phone_number_mask`));
}

function validator(phoneNumber) {
  const phoneNumberReplaced = phoneNumber.replace(/[^\d]/g, '');
  const phoneDigit = I18n.translate(`${I18nRoot}phone_digit`);
  let validate = false;
  $.each(phoneDigit, (i, v) => {
    if (phoneNumberReplaced.length === parseInt(v, 10)) {
      validate = true;
    }
  });
  return validate;
}

// eslint-disable-next-line consistent-return
function submitSMS(e) {
  e.preventDefault();
  if ($('.phoneMasked').val().length === 0) {
    displayErrors(I18n.translate(`${I18nRoot}error_required`));
    return false;
  } else if (!validator($('.phoneMasked').val())) {
    displayErrors(I18n.translate(`${I18nRoot}error_msg`));
    return false;
  }
  $.ajax({
    beforeSend: renderSendInactive,
    complete: renderSendActive,
    type: 'POST',
    data: $('form#sms_message_form').serialize(),
    dataType: 'json',
    url: '/mobile/send_sms_message',
    success(data) {
      if (data && data.status && data.status === 'failure') {
        displayErrors(I18n.translate(`${I18nRoot}error_msg`));
      } else {
        $('.success').show();
        $('#sms_form').hide();
        removeErrors();
      }
    },
    error() {
      displayErrors(I18n.translate(`${I18nRoot}error_msg`));
    },
  });
}

function initMobile() {
  $('#submitButton').on('click', submitSMS);
  $('.phoneMasked').on('focus', maskTextField);
  $('.reset_sms_form').click(() => {
    $('.success').hide();
    $('#sms_form').show();
  });
  IEPlaceholderFix();
}
$(initMobile);

// On ready, add JS class
$(() => {
  document.body.classList.remove('no-js');
  window.Groupon.Performance.pageReady();
});
